import {get} from "app/requests/preview/episodes";
import * as Pages from "components/pages";

export default function PreviewEpisodesTranscript() {
  return <Pages.Public.Episodes.Transcript getEpisode={get} prefix="/preview" />;
}
